import React from 'react';
import bootdesc from '../../../Assets/Image/png/bootdesc.png';

function BootcampDescription() {
    return (
        <div className='pb-[8rem]'>
            <h2 className='text-light-prim1 text-[2rem] mb-[3.6rem]'>توضیحات بوت کمپ</h2>
            <div className='shadow-btn pt-[3.3rem] px-[2.8rem] pb-[3.3rem] rounded-[1.5rem] pagedescription'>
                <h3 >
                    نرم افزار حسابداری محک,طعم جدیدی از حسابداری
                </h3>
                <p >
                    گروه نرم افزاری محک توانسته است، نرم افزار حسابداری خود را در عین سادگی، دقیق، کارآمد و زیبا طراحی کند. استفاده از قابلیت های به روز، باعث شده است که راهکارهای جدیدی برای امور تخصصی ایجاد شود. محک همواره در تلاش است تا ویژگی های محصول خود را در بهترین حالت ممکن قرار دهد و محصولات ارزنده ای به بازار ارائه کند.
                </p>
                <h3>
                    ویژگی های نرم افزار حسابداری محک

                </h3>
                <ul className='mb-[4.7rem] pagedescription__listlist'>
                    <li>
                        سادگی و زیبایی: طراحی نرم افزار حسابداری محک، در عین زیبایی، ساده بوده و به راحتی قابل استفاده می‌باشد.

                    </li>
                    <li>
                        به‌روز بودن: محک با استفاده از جدیدترین تکنولوژی‌ها و فناوری‌ روز دنیا در خدمت شما است.

                    </li>
                    <li>
                        حمایت از مشتری: با پشتیبانی نرم افزار حسابداری محک، دیگر نگران سؤالات و مشکلات خود نخواهید بود.

                    </li>
                    <li>
                        صرفه اقتصادی: استفاده از نرم افزار حسابداری محک در مقایسه با دیگر راهکارها بسیار به‌صرفه است.

                    </li>
                    <li>
                        دقت و امنیت: نرم افزار حسابداری محک از بروز خطای انسانی جلوگیری کرده و دقت محاسبات را افزایش می‌دهد.

                    </li>
                    <li>
                        راه‌کارهای تخصصی: افزونه‌های محک کمک می‌کنند تا در عین سادگی محیطی تخصصی برای صنف خود داشته باشید.

                    </li>
                </ul>

                <img src={bootdesc} className="block m-auto"/>
                <h3 >
                    نرم افزار حسابداری محک,طعم جدیدی از حسابداری
                </h3>
                <p >
                    گروه نرم افزاری محک توانسته است، نرم افزار حسابداری خود را در عین سادگی، دقیق، کارآمد و زیبا طراحی کند. استفاده از قابلیت های به روز، باعث شده است که راهکارهای جدیدی برای امور تخصصی ایجاد شود. محک همواره در تلاش است تا ویژگی های محصول خود را در بهترین حالت ممکن قرار دهد و محصولات ارزنده ای به بازار ارائه کند.
                </p>
                <h3 >
                   سرفصل های دوره
                </h3>
                <ul className='pagedescription__secondlist mb-[3rem]'>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                    <li>آشنایی با کلیات نرم افزارو امکانات کاربردی</li>
                </ul>
            </div>

        </div>
    )
}
export default BootcampDescription